import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class PushesService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Push files to remote
     * Push discovered files as a remote content.
     * Files should be sent as a multipart/form-data.
     * Commit details like commit message and author can be sent as a JSON object in the `commit` field.
     * @returns Push Content pushed.
     * @throws ApiError
     */
    push({ orgId, projectId, formData, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/pushes', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, formData: formData, mediaType: 'multipart/form-data', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of pushes
     * @returns PushList OK.
     * @throws ApiError
     */
    listPushes({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pushes', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get Push by ID
     * @returns Push OK.
     * @throws ApiError
     */
    getPush({ orgId, projectId, pushId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/pushes/{pushId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'pushId': pushId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=PushesService.js.map